// @flow
import React, { Component } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Close from "elevate-ui-icons/Close";
import Button from "elevate-ui/Button";
import Paper from "elevate-ui/Paper";
import Input from "elevate-ui/Input";
import withStyles from "elevate-ui/withStyles";
import { stringify } from "querystring";
import Typography from "elevate-ui/Typography";

type $Props = {
  classes: Object,
  handleSaveToggle: Function,
  query: string,
  visible: boolean,
  savedSearchName: string,
  savedSearchId: number | null,
};

type $State = {
  savedSearchName: string,
  savedSearchId: number | null,
};

class SaveSearch extends Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);
    this.state = {
      savedSearchName: props.savedSearchName,
      savedSearchId: props.savedSearchId,
    };
  }
  savedSearchAction() {
    const { query } = this.props;
    const { savedSearchId, savedSearchName } = this.state;
    if (savedSearchId && savedSearchName) {
      return `/saved-searches/edit/${savedSearchId}/?${stringify(query)}`;
    }
    return `/saved-searches?${stringify(query)}`;
  }
  render() {
    const { classes, visible, handleSaveToggle } = this.props;
    const { savedSearchName, savedSearchId } = this.state;
    return (
      <div
        className={visible ? classes.savedSearchActive : classes.savedSearch}
      >
        <Paper>
          <div className={classes.closeSaveSearch} onClick={handleSaveToggle}>
            <Close /> <span>Close</span>
          </div>
          <Formik
            initialValues={{ name: savedSearchName || "" }}
            validationSchema={() =>
              Yup.object().shape({
                name: Yup.string().required("Search Name is required"),
              })
            }
            onSubmit={() => {
              document.forms["saveSearch"].submit();
            }}
            render={() => (
              <Form
                id="saveSearch"
                name="saveSearch"
                method="POST"
                action={this.savedSearchAction()}
              >
                <Field
                  id="name"
                  name="name"
                  label="Search Name"
                  placeholder="Homes with a pool"
                  component={Input}
                />
                <Typography className={classes.openHouseMessage} type="body2">
                  In order to provide you the best results, your saved search
                  will not use Open house criteria.
                </Typography>
                <Button
                  type="submit"
                  color="secondary"
                  isOutlined
                  style={{ width: "100%", maxWidth: "300px" }}
                >
                  {savedSearchId && savedSearchName ? "Update" : "Save"}
                </Button>
              </Form>
            )}
          />
        </Paper>
      </div>
    );
  }
}

export default withStyles(() => ({
  "@keyframes dropdown": {
    from: { overflow: "hidden", opacity: 0 },
    to: { overflow: "visible", opacity: 1 },
  },
  openHouseMessage: {
    color: "#888f96",
    fontWeight: 600,
  },
  savedSearch: {
    display: "flex",
    margin: "22px auto 0",
    flexFlow: "column",
    justifyContent: "flex-start",
    position: "relative",
    width: "100%",
    maxWidth: "1172px",
    height: "auto",
    maxHeight: "0",
    overflow: "hidden",
  },
  savedSearchActive: {
    display: "flex",
    margin: "22px auto 0",
    flexFlow: "column",
    justifyContent: "flex-start",
    position: "relative",
    width: "100%",
    maxWidth: "1172px",
    height: "auto",
    maxHeight: "10000px",
    overflow: "hidden",
    transition: "all 750ms ease",
    animationName: "dropdown",
    animationDuration: "750ms",
    animationTimingFunction: "ease",
    animationDirection: "forwards",
  },
  closeSaveSearch: {
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "flexStart",
    alignItems: "center",
    margin: "0 0 20px 5px",
    cursor: "pointer",
  },
}))(SaveSearch);
